<template>
  <div class="card-actions action-deal-unsigned">
    <div class="action-deal-unsigned__intro">
      {{ trans('deal_dashboard.action.unsigned.intro') }}
    </div>
    <div class="card-actions__content action-deal-content">
      <div class="action-deal-content__fieldset adcf">
        <div class="input-text">
          <textarea
            v-model="unsignedReason"
            :placeholder="trans('deal_dashboard.action.unsigned.reason_placeholder')"
          />
        </div>

        <span class="label-fields-required">
          {{ trans('global.form.required') }}
        </span>
      </div>
    </div>
    <panel
      v-if="deal.visited_date && isDateInFuture(deal.visited_date.iso)"
      icon="ph_warning-fill_yellow"
      type="warning"
      :content="panelContent"
      :title="trans('messaging.actions.unsigned.panel.title')"
    />
    <div class="card-actions__cta card-actions__cta--bottom">
      <button class="btn btn--secondary btn--cancel" @click="onCancelClick">
        {{ trans('deal_dashboard.action.unsigned.cancel') }}
      </button>
      <button
        class="btn btn--primary"
        :class="{ 'loading-btn': loading }"
        :disabled="isSubmitDisabled"
        @click="submit"
      >
        <span v-if="!loading">
          {{ trans('deal_dashboard.action.unsigned.cta') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Panel from '@components-molecules/Panel.vue';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';
import { URL_XHR_DEAL_STATE_UNSIGNED } from '@tools/routes/routes';
import { Logger } from '@tools/logger/logger';
import { isDateInFuture } from '@tools/date';
import { requestsMixin } from '@tools/requests-mixin';
import { messagingMixins } from '@pages/inbox/mixins';
import { actionsMixins } from './actions-mixins';
import { EVENTS } from './constants';

export default {
  components: { Panel },
  mixins: [ actionsMixins, messagingMixins, requestsMixin ],
  props: {
    deal: { type: Object, required: true },
    interlocutor: { type: Object, required: true },
  },
  data() {
    return {
      title: this.trans('deal_dashboard.action.unsigned.title'),
      loading: false,
      unsignedReason: '',
    };
  },
  computed: {
    isSubmitDisabled() {
      return this.unsignedReason.trim() === '' || this.loading;
    },
    panelContent() {
      return this.trans('messaging.actions.unsigned.panel.content', { name: this.interlocutorFullName(this.deal, true) });
    },
  },
  mounted() {
    this.$emit(EVENTS.TITLE_UPDATE, this.title);
  },
  methods: {
    isDateInFuture,
    onCancelClick() {
      this.$emit(EVENTS.ACTION_CANCELLED);
    },
    async submit() {
      this.loading = true;
      let response = null;
      try {
        response = await this.post(
          URL_XHR_DEAL_STATE_UNSIGNED.replace('{id}', this.deal.id),
          {
            unsignedReason: this.unsignedReason,
            cancelledDate: this.deal.visited_date ? this.deal.visited_date.iso : null,
          },
        );
      } catch (error) {
        Logger.error(error);
      }
      this.loading = false;
      if (response && response.status === 200) {
        flashBagSuccess(this.trans('deal_dashboard.action.success'));
        this.$emit(EVENTS.ACTION_PERFORMED);
        return;
      }
      flashBagError(this.trans('deal_dashboard.action.failure'));
    },
  },
};
</script>
